import React from 'react'
import { message, Modal } from 'antd'
import styled from 'styled-components'
import { CustomReportConfig } from '@/component/common/report/reportConfigModel'
import { AlertMenuItem } from '../AlertMenu/AlertMenuItem'
import _ from 'lodash'

const AlertModalView = styled(Modal)`
  &.ant-modal{
    top:50px;
    bottom: 50px;
    height: calc(100% - 100px);
    >div{
      height:100%;
    }
  }
  .ant-modal-body{
    border-top: 1px solid #e9e9e9;
  }
  .alert-item{
    display: flex;
    height: 60px;
    /* border-bottom: 1px solid #e9e9e9; */
    align-items: center;
    /* margin: 0 -24px;
    padding: 0 24px; */
    .text{
      color: rgba(0,0,0,0.65)
    }
    .name{
      width: 150px;
      font-weight: 500;
    }
  }
  &.ant-modal{
    .ant-modal-content{
      padding-left:0;
      padding-right:0;
      .ant-modal-body{
        padding: 15px;
      }
    }
    .ant-modal-footer{
      padding-right: 15px;
      border-top: 1px solid #e9e9e9;
      padding-top: 15px;
    }
  }
  .ant-modal-header{
    margin-bottom: 15px;
  }
  .ant-modal-title{
    padding-left: 15px;
  }
  
  &.ant-modal .ant-modal-content{
    max-height:100%;
    display:flex;
    flex-direction: column;
    padding-bottom: 15px;
    padding-top: 15px;
    .ant-modal-body{
      flex:1;
      overflow: auto;
    }
  }


`


type AlertModalProps = {
  alertMenu: CustomReportConfig['alertMenu'],
  onOk(varialbe: Required<CustomReportConfig>['alertMenu']["variable"]): void
  open: boolean
  onCancel():void
}



export const AlertModal = (props: AlertModalProps) => {
  const { alertMenu,open,onOk,onCancel} = props
  const { menu = [] } = alertMenu || {}
  const [variable,setVariable] = React.useState(alertMenu?.variable || {})
  React.useEffect(()=>{ 
    setVariable(_.cloneDeep(alertMenu?.variable) || {})
  },[alertMenu?.variable])
  React.useEffect(()=>{
    if(open){
      setVariable(_.cloneDeep(alertMenu?.variable) || {})
    }
  },[open])
  const onChange = (variableKey:string,value:string)=>{
    setVariable(variable=>{
      if(!variable){
        return variable
      }
      let currentVariable = variable[variableKey]
      if(currentVariable.display_type == 'input'){
        if(value !== undefined && value !== null){
          value = Math.floor(Number(value)).toString()
        }
      }
      variable[variableKey].key_value = value
      return {...variable}
    })
  }
  const getError = (variable: Required<CustomReportConfig>['alertMenu']["variable"])=>{
    let error:string[] = []
    Object.keys(variable).forEach((key: string)=>{
      let variableItem = variable[key];
      if(variableItem.display_type == 'input'){
        let range = variableItem.range
        let {key_value,key_name} = variableItem
        if(range){
          if(Number(key_value) > Number(range.max) || Number(key_value) < Number(range.min)){
            error.push(`"${key_name}"输入值"${key_value}"超出范围${range.min}~${range.max}`)
            return true
          }
        }
      }
    })
    if(!error.length){
      return false
    }
    return error.join(';')

  }
  const onSure =  async  (variable: Required<CustomReportConfig>['alertMenu']["variable"]) => {
    let error = getError(variable)
    if(error){
      message.error(error)
      return
    }
    onOk(variable);
  }
  return <AlertModalView
    title={'预警指标设置'}
    open={open}
    onOk={()=>onSure(variable)}
    onCancel={onCancel}
    destroyOnClose
    width={750}
  >
    {menu.map(item => {
      return <div className='alert-item' key={item.id}>
        <div className='name'>{ item.key_name }</div>
        <AlertMenuItem  onChange={onChange} variable={variable}  menuItem={item}  isEdit />
      </div>
    })}


  </AlertModalView>
}